import React, { Children, useState } from 'react'
import ReactCarousel, { Dots } from '@brainhubeu/react-carousel'

import { IconButton, IconButtonProps } from '../IconButton'

interface CarouselButtonProps extends IconButtonProps {
  side: 'left' | 'right'
}

export const CarouselButton = ({ side, ...restProps }: CarouselButtonProps) => (
  <IconButton
    icon={side === 'left' ? 'arrow-back' : 'arrow-forward'}
    isRound
    variant="unstyled"
    fontSize="2xl"
    bg="blackAlpha.400"
    h="2rem"
    w="2rem"
    color="white"
    position="absolute"
    top="50%"
    left={side === 'right' ? ['calc(100% - 2.5rem)', , 'calc(100% + 0.5rem)'] : null}
    right={side === 'left' ? ['calc(100% - 2.5rem)', , 'calc(100% + 0.5rem)'] : null}
    transform="translateY(-50%)"
    zIndex={5}
    display={['none', , 'flex']}
    {...restProps}
  />
)

export const CarouselButtonNew = ({ side, ...restProps }: CarouselButtonProps) => (
  <IconButton
    icon={side === 'left' ? 'arrow-back' : 'arrow-forward'}
    isRound
    variant="unstyled"
    fontSize="2xl"
    position="absolute"
    bg="blackAlpha.400"
    h="2rem"
    w="2rem"
    left={side === 'left' ? 0 : ''}
    right={side === 'right' ? 0 : ''}
    color="white"
    zIndex={5}
    display={['none', , 'flex']}
    {...restProps}
  />
)

/////////////////////////////////////////////////////////////////////////////////////////////////

export interface CarouselProps {
  arrowLeft?: React.ReactNode
  arrowLeftDisabled?: React.ReactNode
  arrowRight?: React.ReactNode
  arrowRightDisabled?: React.ReactNode
  infinite?: boolean
  arrows?: boolean
  autoPlay?: number
  slidesPerPage?: number
  children?: React.ReactNode
  breakpoints?: any
  showDots?: boolean
}

export const Carousel = ({
  children,
  arrowLeft,
  arrowLeftDisabled,
  arrowRight,
  arrowRightDisabled,
  showDots,
  ...restProps
}: CarouselProps) => {
  const [value, setValue] = useState(0)

  const numberOfSlides = Children.toArray(children).length

  return (
    <>
      <ReactCarousel
        value={value}
        onChange={setValue}
        addArrowClickHandler
        arrowLeft={arrowLeft || <CarouselButton side="left" />}
        arrowLeftDisabled={arrowLeftDisabled || <CarouselButton side="left" isDisabled />}
        arrowRight={arrowRight || <CarouselButton side="right" />}
        arrowRightDisabled={arrowRightDisabled || <CarouselButton side="right" isDisabled />}
        {...restProps}
      >
        {children}
      </ReactCarousel>

      {showDots && <Dots value={value} onChange={setValue} number={numberOfSlides} />}
    </>
  )
}

export default Carousel
